import {
    Button,
    Message,
    DatePicker,
    Input,
    InputNumber,
    Table,
    TableColumn,
    Pagination,
    Dialog,
    Select,
    TimeSelect,
    Option,
    OptionGroup,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Loading,
    Empty,
    Upload,
} from 'element-ui';

const element = {
    install: function (Vue) {
        Vue.use(Pagination);
        Vue.use(Button);
        Vue.use(DatePicker);
        Vue.use(Input);
        Vue.use(InputNumber);
        Vue.use(Table);
        Vue.use(TableColumn);
        Vue.use(Dialog);
        Vue.use(Select);
        Vue.use(TimeSelect);
        Vue.use(Option);
        Vue.use(OptionGroup);
        Vue.use(Checkbox);
        Vue.use(CheckboxButton);
        Vue.use(CheckboxGroup);
        Vue.use(Dropdown);
        Vue.use(DropdownMenu);
        Vue.use(DropdownItem);
        Vue.use(Empty);
        Vue.use(Upload);
        Vue.use(Loading.directive);
        Vue.prototype.$loading = Loading.service;

        Vue.prototype.$message = Message;
    }
}

export default element
